import { render } from "./Crest.vue?vue&type=template&id=ef32042c"
import script from "./Crest.vue?vue&type=script&lang=js"
export * from "./Crest.vue?vue&type=script&lang=js"

import "./Crest.vue?vue&type=style&index=0&id=ef32042c&lang=css"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__